import React from 'react';
import './Styles.css';
import { formatMessage } from '../../../Localization/formatMessage';
import Messages from '../../../Localization/Messages';
import CommissionHistory from './CommissionHistory/';
import { convertServerDateTime } from '../../../Helpers/Converter';
import { Button, ButtonSize, ButtonType } from '@ids/react-button';

const ExpandedView = ({ brokerCostRate, openModal }) => {
  return (
    <tr className="commission-page_expanded-view-container">
      <td colSpan={13}>
        <div className="commission-page_expanded-view-details">
          <div>
            <b>{formatMessage(Messages.commissionPage_ValidFrom)}</b>
            <br />
            {convertServerDateTime(brokerCostRate?.effective)}
          </div>
          <div>
            <b>{formatMessage(Messages.commissionPage_ValidTo)}</b>
            <br />
            {convertServerDateTime(brokerCostRate?.expires)}
          </div>
          <div>
            <b>{formatMessage(Messages.commissionPage_Updated)}</b>
            <br />
            {convertServerDateTime(brokerCostRate?.updated)}
          </div>
          <div>
            <b>{formatMessage(Messages.common_updatedBy)}</b>
            <br />
            {brokerCostRate.updatedBy ? (
              <>
                {brokerCostRate.updatedBy.sourceSystem}
                <br />
                {brokerCostRate.updatedBy.userIdentifier}
              </>
            ) : (
              '-'
            )}
          </div>
          <div>
            <Button size={ButtonSize.MEDIUM} type={ButtonType.FILLED} onClick={openModal}>
              {formatMessage(Messages.common_edit)}
            </Button>
          </div>
        </div>

        <CommissionHistory agentCode={brokerCostRate.agentCode} customerNumber={brokerCostRate.customerNumber} />
      </td>
    </tr>
  );
};
export default ExpandedView;
